/* eslint-disable no-console */
import { RequestTracker } from "../../interfaces/reqTracker";
import trackerConstants from "../constants/trackersTypes";

export const setGCLID = (gclId: string) => async (dispatch: any) => {
  try {
    dispatch({ type: trackerConstants.SET_GCLID, value: gclId });
  } catch (error) {
    console.log("gclId tracking error: ", error);
  }
};

export const resetGCLID = () => async (dispatch: any) => {
  try {
    dispatch({ type: trackerConstants.RESET_GCLID });
  } catch (error) {
    console.log("gclId reset error: ", error);
  }
};

export const trackRequest = (data: any) => async (_: any, getState: Function) => {
  try {
    const profile = getState().firebase.profile;

    const payload: RequestTracker = {
      body: data,
      requestBy: {
        uid: profile.uid,
        email: profile.email,
        userType: profile.userType,
      },
      meta: {
        referer: window.location.href,
      }
    };

    // const response = await useAxiosPost("/trackers/request", payload);
    // return Boolean(response?.data?.success);
    return true;
  } catch (error) {
    console.log("Error tracking request: ", error);
    return false;
  }
};
